import { datadogRum } from '@datadog/browser-rum';
import { nextjsPlugin } from '@datadog/browser-rum-nextjs';

import { parseFloatWithFallback } from '@pflegia/util/common/parse-float-with-fallback';

import { EXCLUDED_ACTIVITY_URLS } from './shared/monitoring/excluded-activity-urls';

const MIN_SAMPLE_RATE = 0;
const MAX_SAMPLE_RATE = 100;
const DEFAULT_SESSION_SAMPLE_RATE = MAX_SAMPLE_RATE;
const DEFAULT_REPLAY_SAMPLE_RATE = 5;

const parseSampleRate = (input: string | undefined, fallback: number) =>
  parseFloatWithFallback(input, fallback, { min: MIN_SAMPLE_RATE, max: MAX_SAMPLE_RATE });

if (process.env.NEXT_PUBLIC_DATADOG_ENABLED === 'true') {
  datadogRum.init({
    allowedGraphQlUrls: [new URL('/graphql', process.env.NEXT_PUBLIC_BACKEND_ENDPOINT).toString()],
    allowedTracingUrls: [new URL('/', process.env.NEXT_PUBLIC_BACKEND_ENDPOINT).toString()],
    applicationId: '2756d5f4-d0d4-4d92-a13b-cfdf3f9392aa',
    clientToken: 'pub477886806d78a116f03fffefce8e32d6',
    defaultPrivacyLevel: 'mask-user-input',
    env: process.env.NEXT_PUBLIC_ENV,
    excludedActivityUrls: EXCLUDED_ACTIVITY_URLS,
    plugins: [nextjsPlugin()],
    service: 'pflegia-web',
    sessionReplaySampleRate: parseSampleRate(process.env.NEXT_PUBLIC_REPLAY_SAMPLE_RATE, DEFAULT_REPLAY_SAMPLE_RATE),
    sessionSampleRate: parseSampleRate(process.env.NEXT_PUBLIC_SESSION_SAMPLE_RATE, DEFAULT_SESSION_SAMPLE_RATE),
    site: 'datadoghq.eu',
    trackingConsent: 'not-granted',
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    version: process.env.NEXT_PUBLIC_COMMIT_SHA,
  });
}
